import React from "react";
import Feature from "./Feature";


const FeatureCollection = ({data}) => {
    const {features} = data;
    return (
        <>
            {
                features.map((featureData, key) =>
                    <Feature key={key} data={featureData}/>
                )
            }
        </>
    );
};

export default FeatureCollection;